import "inputmask"
$(document).ready(function() {
    $('input[type="checkbox"]').on('change', function () {
        $(this).parents('.js-checkbox-label').toggleClass('checked');
    })

    $('.js-user-show').on('click', function(e) {
        e.preventDefault();

        $('.dental-menu__menu').addClass('show');
        $('.dental-menu__menu').after('<div class="modal-backdrop show menu"></div>')
    })

    $('body').on('click', '.modal-backdrop.show.menu', function () {
        $('.dental-menu__menu').removeClass('show');
        $('.modal-backdrop.show.menu').remove();
    })

    Inputmask("+7 (999) 999-99-99").mask(".phone-mask");

    const masks = {
        "+7": "+7 (999) 999-99-99", // Россия
        "+375": "+375 (99) 999-99-99", // Беларусь
    };

    // Функция для определения маски по введенному коду страны
    function getMaskByPhoneNumber(phoneNumber) {
        // Проверяем начало номера на соответствие кодам стран
        for (const code in masks) {
            if (phoneNumber.startsWith(code)) {
                return masks[code];
            }
        }
        return "+999 999 999 999"; // Общая маска, если код страны не распознан
    }

    // Применяем маску ко всем элементам с классом .phone-mask-multi
    document.querySelectorAll('.phone-mask-multi').forEach(input => {

        const value = input.value
        let maskInstance = null;

        // Функция для обновления маски
        function updateMask() {
            const currentValue = input.value.replace(/\D/g, ''); // Убираем все нецифровые символы
            const newMask = getMaskByPhoneNumber("+" + currentValue);

            // Если маска изменилась, обновляем её
            if (!maskInstance || maskInstance.opts.mask !== newMask) {
                if (maskInstance) {
                    maskInstance.remove(); // Удаляем старую маску
                    console.log('clear')
                    input.value = ""; // Очищаем поле
                }
                maskInstance = Inputmask({
                    mask: newMask,
                    placeholder: "_",
                    showMaskOnHover: false,
                    showMaskOnFocus: true,
                    greedy: false,
                    clearIncomplete: false,
                    onBeforeMask: function (value) {
                        return value.replace(/\D/g, '');
                    },
                    onBeforePaste: function (pastedValue) {
                        return pastedValue.replace(/\D/g, '');
                    }
                }).mask(input);
            }
        }

        // Отслеживаем изменения значения поля
        input.addEventListener('input', function () {
            updateMask();
        });

        // Обработка удаления символов
        input.addEventListener('keydown', function (event) {
            if (event.key === 'Backspace' || event.key === 'Delete') {
                // Если поле пустое или содержит только "+", сбрасываем маску
                const currentValue = input.value.replace(/\D/g, '');
                if (currentValue.length <= 1) {
                    if (maskInstance) {
                        maskInstance.remove(); // Удаляем старую маску
                    }
                    maskInstance = Inputmask({
                        mask: "+999 999 999 999",
                        placeholder: "_",
                        showMaskOnHover: false,
                        showMaskOnFocus: true,
                        greedy: false,
                        clearIncomplete: false,
                        onBeforeMask: function (value) {
                            return value.replace(/\D/g, '');
                        }
                    }).mask(input);
                }
            }
        });

        // Инициализация маски при загрузке
        updateMask();

        if (value.startsWith('7')) {
            input.value = value.substring(1);
        } else if (value.startsWith('375')) {
            input.value = value.substring(3);
        }
    });
});
